import React, { useState, useEffect } from "react";

// import JS files
import MuiModal from "../../mui/MuiModal";
import MuiButton from "../../mui/MuiButton";
import { Province } from "../../../Province";
import moment from "jalali-moment";

// import Others files

const SubsModal = ({
  width,
  isOverflow,
  isNotBackdropClick,
  openModal,
  setOpenModal,
  disableEscapeKeyDown = true,
  data,
  // disableBackdropClick = true,
}) => {
  console.log("dddd", data);
  return (
    <>
      <MuiModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        width={width}
        isOverflow={isOverflow}
        isNotBackdropClick={isNotBackdropClick}
        disableEscapeKeyDown={disableEscapeKeyDown}
      >
        <p className="text-myblack-100 text-center">لیست افراد تحت تکفل</p>
        <div className="bg-slate-200 grid grid-cols-2 md:grid-cols-9 items-center text-center bg-mygray-200 p-2 rounded-lg text-mygray-700 text-xs my-2 font-bold mt-4">
          <span>نام و نام خانوادگی</span>
          <span className="hidden md:inline">تاریخ تولد</span>
          <span className="hidden md:inline">کدملی</span>
          <span className="hidden md:inline">شماره شناسنامه</span>

          <span className="hidden md:inline">نام پدر</span>
          <span className="hidden md:inline">محل تولد</span>
          <span className="hidden md:inline">نسبت</span>
        </div>
        {data.treatment_request_main_insured[0].sub_insured.map((it, ind) => {
          return [
            <div className="border border-dashed grid grid-cols-2 md:grid-cols-9 items-center text-center bg-mygray-200 p-2 rounded-lg text-mygray-700 text-xs my-2">
              {" "}
              <span>{it.first_name + " " + it.last_name}</span>
              <span className="hidden md:inline">
                {" "}
                {moment(it.birth_date, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </span>
              <span className="hidden md:inline">{it.code}</span>
              <span className="hidden md:inline">{it.identity_num}</span>
              <span className="hidden md:inline">{it.father_name}</span>
              <span className="hidden md:inline">
                {
                  Province.filter((its) => its.value == it.birth_provience)[0]
                    .name
                }{" / "}
                {it.birth_city}
              </span>
              <span className="hidden md:inline">{it.fa_relation}</span>
            </div>,
          ];
        })}
      </MuiModal>
    </>
  );
};

export default SubsModal;
